import React from 'react';
import Chart from '../Chart/Chart';

const ExamPaperStatLineChart = (props) => {
  const { options, series, isDataLoaded } = props;
  return isDataLoaded ? <Chart options={options} series={series} type="line" width={500} /> : null;
};

export default ExamPaperStatLineChart;
